<template>
  <div class="tile">
    <h4 class="tile__heading">{{ displayName }}</h4>
    <img class="tile__image" :class="{ 'tile__image--larger' : !desc }"  :src=image />
    <p class="tile__text">{{ desc }}</p>
    <div class="tile__button-container">
      <button v-if="selected" class="tile__button tile__button--selected">
        Selected
      </button>
      <button 
        v-else 
        @click="$emit('tile-clicked', { 'purpose': purpose, 'name': name, 'displayName' : displayName })" 
        class="tile__button"
      >
        Choose
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String, 
      default: ''
    },
    displayName: {
      type: String, 
      default: ''
    },
    desc: {
      type: String, 
      default: ''
    },
    purpose: {
      type: String, 
      default: ''
    },
    selected: {
      type: Boolean,
      default: false 
    },
    image: {
      type: String, 
      default: ''
    }
  }, 
  methods: {

  }
}
</script>